import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';




@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {

  constructor(private route: ActivatedRoute, private Router: Router) {
  }

  // ngOnInit(): void {
  //   this.route.queryParams.subscribe(params => {
  //     console.log('Payment result:', params);

  //     const status = params['status'];

  //     if (status === 'success') {
  //       this.Router.navigateByUrl('/applicant-login');
  //     } else {
  //       this.Router.navigateByUrl('/payment-failure');
  //     }
  //     // Optionally verify payment status with backend here
  //   });
  // }


  // ngOnInit(): void {
  //   this.route.queryParams.subscribe(params => {
  //     console.log('Payment success component loaded with params:', params);
  //   });
  // }



  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const status = params['status'];
      const txnid = params['txnid'];

      if (status === 'success') {
        Swal("Payment Successful!", `Transaction ID: ${txnid || 'N/A'}`, "success")
          .then(() => {
            this.Router.navigate(['/applicant-login']);
          });
      } else {
        Swal("Payment Failed", "Something went wrong during payment.", "error")
          .then(() => {
            this.Router.navigate(['/payment-failure']);
          });
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/registration/payment-success/payment-success.component.ts